module.exports = __webpack_public_path__ + "img/2025.0efb1f44.png";